// Logos reused from /public/images/multi-vendor/
export const crmTrustedLogos = [
  { src: "/images/multi-vendor/casevilla.png", alt: "The CaseVilla" },
  { src: "/images/multi-vendor/colorbar.png", alt: "Colorbar" },
  { src: "/images/multi-vendor/health.png", alt: "Health Wellness Shop" },
  { src: "/images/multi-vendor/necked.png", alt: "Necked" },
  { src: "/images/multi-vendor/tarohi.png", alt: "Tarohi Jewels" },
  { src: "/images/multi-vendor/toyzhub.png", alt: "ToyzHub" },
  { src: "/images/multi-vendor/vastralipi_logo.png", alt: "Vastralipi" },
  { src: "/images/multi-vendor/suruchira.png", alt: "Suruchira" },
  { src: "/images/multi-vendor/Jewelled-by-vandana.png", alt: "Jewelled by Vandana" },
];

export const crmKeyBenefits = [
  {
    icon: "/images/crm/key-benefit-1.png",
    title: "Strong customer relationship",
    description:
      "Build apps that enable your business to provide a personalized service experience. This helps in building stronger bonds and customer loyalty.",
  },
  {
    icon: "/images/crm/key-benefit-2.png",
    title: "Services on the go",
    description:
      "Your esteemed customers can access a variety of services while on the go. This adds convenience to make their lifestyle hassle-free.",
  },
  {
    icon: "/images/crm/key-benefit-3.png",
    title: "On-time services",
    description:
      "On-demand home service app development can be customized with features like real-time tracking to ensure that services are quick.",
  },
  {
    icon: "/images/crm/key-benefit-4.png",
    title: "Brand awareness",
    description:
      "You can leverage the best of on-demand home service app development benefits to increase the visibility of your brand beyond boundaries.",
  },
  {
    icon: "/images/crm/key-benefit-5.png",
    title: "Inexpensive and quick",
    description:
      "Solutions for on-demand services for home connect users with cost-effective services quickly that save both money and time.",
  },
  {
    icon: "/images/crm/key-benefit-6.png",
    title: "Anytime & anywhere",
    description:
      "As the name suggests, on-demand home services through software solutions are available from anywhere and at any time.",
  },
];

export const crmSolutionTypes = [
  {
    image: "/images/crm/type-1.png",
    title: "Home service businesses",
    description:
      "Build solutions that can assist you in offering home services to your customers. You can manage all of your services under one dashboard for easy management.",
  },
  {
    image: "/images/crm/type-2.png",
    title: "Multi-service aggregators",
    description:
      "Got more than one on-demand home service? No problem. Get our multi-service business solution wherein you can bring all your ventures into one entity.",
  },
  {
    image: "/images/crm/type-3.png",
    title: "Single-service aggregator",
    description:
      "Our home service app development can be personalized depending on your specific needs and customer requirements.",
  },
];

export const crmPanels = [
  {
    title: "Powerful Admin Panel",
    description:
      "Manage your on-demand home service business effortlessly with a feature-rich admin panel. Track operations, analyze data, and enhance efficiency with ease.",
    image: "/images/crm/powerful-admin-panel.png",
    imageAlt: "Powerful Admin Panel",
    circle: "green" as const,
    check: "green" as const,
    imageSide: "left" as const,
    features: [
      "Dashboard Analytics",
      "Revenue Tracking",
      "Service Management",
      "Push Notifications",
      "User Management",
      "Commission & Payouts",
      "Booking Management",
      "Review & Feedback System",
    ],
  },
  {
    title: "Service Provider Panel",
    description:
      "Empower service providers with a seamless platform to manage their tasks efficiently and grow their business.",
    image: "/images/crm/service-provider-panel.png",
    imageAlt: "Service Provider Panel",
    circle: "blue" as const,
    check: "blue" as const,
    imageSide: "right" as const,
    features: [
      "Profile Management",
      "In-App Chat & Notifications",
      "Service Requests",
      "Job History",
      "Earnings Dashboard",
      "Review & Ratings",
      "Availability Management",
      "Location Tracking",
    ],
  },
  {
    title: "Branch Panel",
    description:
      "Manage multiple service branches efficiently with an advanced branch panel for seamless operations.",
    image: "/images/crm/branch -panel.png",
    imageAlt: "Branch Panel",
    circle: "green" as const,
    check: "green" as const,
    imageSide: "left" as const,
    features: [
      "Branch Dashboard",
      "Performance Reports",
      "Staff Management",
      "Inventory Management",
      "Service Listings",
      "Customer Support",
      "Booking Allocation",
      "Geo-Location Tracking",
    ],
  },
  {
    title: "Customer Panel",
    description:
      "A user-friendly interface to book services quickly, track requests, and connect with providers effortlessly.",
    image: "/images/crm/customer-panel.png",
    imageAlt: "Customer Panel",
    circle: "blue" as const,
    check: "blue" as const,
    imageSide: "right" as const,
    features: [
      "Easy Service Booking",
      "Ratings & Reviews",
      "Real-Time Tracking",
      "Personalized Recommendations",
      "Secure Payment Options",
      "24/7 Support",
      "Service History",
      "Promos & Discounts",
    ],
  },
];

export type CrmTechItem = {
  name: string;
  /** Logo path — swap these for your own files any time */
  image: string;
};

export type CrmTechTab = {
  id: string;
  label: string;
  items: CrmTechItem[];
};

const LOGO = "/images/multi-vendor/images/logo";

export const crmTechTabs: CrmTechTab[] = [
  {
    id: "frameworks",
    label: "Frameworks",
    items: [
      { name: "Flutter", image: `${LOGO}/flutter-sdk.png` },
      { name: "Flutter SDK", image: `${LOGO}/flutter-sdk.png` },
      { name: "Dart SDK", image: `${LOGO}/dart-sdk.png` },
      // { name: "React", image: `${LOGO}/react.png` },
      // { name: "Vue", image: `${LOGO}/vue.png` },
    ],
  },
  {
    id: "tools",
    label: "Tools & Utilities",
    items: [
      { name: "Android Studio", image: `${LOGO}/android-studio.png` },
      { name: "Visual Studio", image: `${LOGO}/visual-studio.png` },
      { name: "Git", image: `${LOGO}/git.png` },
      { name: "Git Lab", image: `${LOGO}/git-lab.png` },
      { name: "Bit Bucket", image: `${LOGO}/bit-bucket.png` },
       { name: "Azure", image: `${LOGO}/azure.png` },
    ],
  },
  {
    id: "database",
    label: "Database",
    items: [
      { name: "Firebase", image: `${LOGO}/firebase.png` },
      { name: "MongoDB", image: `${LOGO}/mongodb.png` },
      { name: "PostgreSQL", image: `${LOGO}/postgresql.png` },
      { name: "SQLite", image: `${LOGO}/sqlite.png` },
    ],
  },
  {
    id: "cicd",
    label: "CI/CD Tools",
    items: [
      { name: "Codemagic", image: `${LOGO}/codemagic.png` },
      { name: "Cirrus", image: `${LOGO}/cirrus.png` },
      { name: "Travis", image: `${LOGO}/travis.png` },
    ],
  },
  {
    id: "testing",
    label: "Testing",
    items: [
      { name: "Postman", image: `${LOGO}/postman.png` },
      { name: "Selenium", image: `${LOGO}/selenium.png` },
      { name: "Test Rail", image: `${LOGO}/test-rail.png` },
      { name: "Apache JMeter", image: `${LOGO}/apache-jmeter.png` },
    ],
  },
  {
    id: "cloud",
    label: "Cloud",
    items: [
      { name: "AWS", image: `${LOGO}/aws.png` },
      // google-cloud.png / digitalocean.png are not in that folder yet — add them
      // { name: "Google Cloud", image: `${LOGO}/google-cloud.png` },
      { name: "Azure", image: `${LOGO}/azure.png` },
      // { name: "DigitalOcean", image: `${LOGO}/digitalocean.png` },
      // { name: "Firebase", image: `${LOGO}/firebase.png` },
    ],
  },
];

export const crmWhyChoose = [
  {
    icon: "/images/crm/why-1.png",
    title: "Custom Solutions",
    description:
      "Tailored app development to meet your unique business needs.",
  },
  {
    icon: "/images/crm/why-2.png",
    title: "Seamless User Experience",
    description:
      "Intuitive design for effortless navigation and interaction.",
  },
  {
    icon: "/images/crm/why-3.png",
    title: "Robust Security",
    description: "Advanced encryption and data protection for user safety.",
  },
  {
    icon: "/images/crm/why-4.png",
    title: "Scalable Architecture",
    description: "Future-ready solutions that grow with your business.",
  },
  {
    icon: "/images/crm/why-5.png",
    title: "24/7 Support",
    description: "Dedicated assistance to keep your app running smoothly.",
  },
];

export const crmIndustries = [
  {
    id: "carpenter",
    title: "Carpenter Services",
    icon: "/images/crm/industry-carpenter.png",
    heading: "Carpenter Services",
    description:
      "Elevate your carpentry business with our smart app solutions. Manage appointments, track inventory, process payments, and enhance customer engagement—all in one place.",
    points: [
      "Effortless Appointment Scheduling",
      "Smart Inventory Management",
      "Seamless Payment Processing",
      "Personalized Customer Experience",
      "Real-time Business Insights",
    ],
  },
  {
    id: "beauty",
    title: "Beauty Services",
    icon: "/images/crm/industry-beauty.png",
    heading: "Beauty Services",
    description:
      "Elevate your beauty business with our smart app solutions. Manage appointments, track inventory, process payments, and enhance customer engagement—all in one place.",
    points: [
      "Effortless Appointment Scheduling",
      "Smart Inventory Management",
      "Seamless Payment Processing",
      "Personalized Customer Experience",
      "Real-time Business Insights",
    ],
  },
  {
    id: "childcare",
    title: "Child Care Services",
    icon: "/images/crm/industry-childcare.png",
    heading: "Child Care Services",
    description:
      "Elevate your child care business with our smart app solutions. Manage appointments, track inventory, process payments, and enhance customer engagement—all in one place.",
    points: [
      "Effortless Appointment Scheduling",
      "Smart Inventory Management",
      "Seamless Payment Processing",
      "Personalized Customer Experience",
      "Real-time Business Insights",
    ],
  },
  {
    id: "home",
    title: "Home Improvement",
    icon: "/images/crm/industry-home.png",
    heading: "Home Improvement",
    description:
      "Elevate your home improvement business with our smart app solutions. Manage appointments, track inventory, process payments, and enhance customer engagement—all in one place.",
    points: [
      "Effortless Appointment Scheduling",
      "Smart Inventory Management",
      "Seamless Payment Processing",
      "Personalized Customer Experience",
      "Real-time Business Insights",
    ],
  },
  {
    id: "handyman",
    title: "Handyman Services",
    icon: "/images/crm/industry-handyman.png",
    heading: "Handyman Services",
    description:
      "Elevate your handyman business with our smart app solutions. Manage appointments, track inventory, process payments, and enhance customer engagement—all in one place.",
    points: [
      "Effortless Appointment Scheduling",
      "Smart Inventory Management",
      "Seamless Payment Processing",
      "Personalized Customer Experience",
      "Real-time Business Insights",
    ],
  },
  {
    id: "cleaning",
    title: "Cleaning Services",
    icon: "/images/crm/industry-cleaning.png",
    heading: "Cleaning Services",
    description:
      "Elevate your cleaning business with our smart app solutions. Manage appointments, track inventory, process payments, and enhance customer engagement—all in one place.",
    points: [
      "Effortless Appointment Scheduling",
      "Smart Inventory Management",
      "Seamless Payment Processing",
      "Personalized Customer Experience",
      "Real-time Business Insights",
    ],
  },
  {
    id: "painting",
    title: "Painting Services",
    icon: "/images/crm/industry-painting.png",
    heading: "Painting Services",
    description:
      "Elevate your painting business with our smart app solutions. Manage appointments, track inventory, process payments, and enhance customer engagement—all in one place.",
    points: [
      "Effortless Appointment Scheduling",
      "Smart Inventory Management",
      "Seamless Payment Processing",
      "Personalized Customer Experience",
      "Real-time Business Insights",
    ],
  },
  {
    id: "electrical",
    title: "Electrical Services",
    icon: "/images/crm/industry-electrical.png",
    heading: "Electrical Services",
    description:
      "Elevate your electrical business with our smart app solutions. Manage appointments, track inventory, process payments, and enhance customer engagement—all in one place.",
    points: [
      "Effortless Appointment Scheduling",
      "Smart Inventory Management",
      "Seamless Payment Processing",
      "Personalized Customer Experience",
      "Real-time Business Insights",
    ],
  },
  {
    id: "laundry",
    title: "Laundry Services",
    icon: "/images/crm/industry-laundry.png",
    heading: "Laundry Services",
    description:
      "Elevate your laundry business with our smart app solutions. Manage appointments, track inventory, process payments, and enhance customer engagement—all in one place.",
    points: [
      "Effortless Appointment Scheduling",
      "Smart Inventory Management",
      "Seamless Payment Processing",
      "Personalized Customer Experience",
      "Real-time Business Insights",
    ],
  },
];

export const crmHowItWorks = [
  {
    step: "1",
    icon: "/images/flutter/discovery-phase.png",
    title: "Place Order",
    description:
      "Customers request a service by selecting the required home service and confirming their booking through the app.",
  },
  {
    step: "2",
    icon: "/images/flutter/planning-design.png",
    title: "Resource Alloted",
    description:
      "The app assigns the request to an available service provider, ensuring a seamless and timely response.",
  },
  {
    step: "3",
    icon: "/images/flutter/development.png",
    title: "Order Accepted",
    description:
      "The service provider accepts the request, reviews the service details, and prepares for the scheduled task.",
  },
  {
    step: "4",
    icon: "/images/flutter/testing-quality-assurance.png",
    title: "Payment Initiated",
    description:
      "The payment is processed securely through the app, with options for advance or post-service transactions.",
  },
  {
    step: "5",
    icon: "/images/flutter/deployment.png",
    title: "Service Delivered",
    description:
      "The assigned professional arrives at the customer's location and completes the requested service efficiently.",
  },
];
